export default __webpack_public_path__ + "static/media/mobility_simulation.6ba4d259.svg";